var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"training",staticClass:"training",class:{ 'training--fullscreen': _vm.isFullscreen }},[_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.getImage(_vm.slideName),"alt":"Demo example"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }